import { merge } from '../../helper';

import exLanguage from '../../language';
import * as exModal from '../../components/modal';

// ----------------------------------------------------------------------------

function create(element: HTMLElement, config: Record<string, any> = {}): void {
    // If table is no table element
    if (!(element instanceof HTMLTableElement)) {
        console.error('Is not an element table...');
        return;
    }

    // Default Config
    const defConfig: Record<string, any> = {
        event: 'dblclick',
        selector: 'tbody > tr > td',
        className: 'table-detail',
        toggleable: true,
    };

    // Merge
    merge(defConfig, config);

    // --------------------------------------------------------------------

    // Create event
    (window as any).$(element).on(defConfig.event, defConfig.selector, function (this: any, evt): any {
        const elCell = this as HTMLTableCellElement;
        const elRow = elCell.closest('tr');

        if (!(elRow instanceof HTMLTableRowElement) || elRow.hasClass(defConfig.className)) {
            return;
        }

        const elNextRow = elRow.nextElementSibling as HTMLElement | null;

        if (elNextRow?.hasClass(defConfig.className)) {
            if (defConfig.toggleable === true) {
                elNextRow.remove();
            }

            return;
        }

        let data = defConfig.data;

        // If using function data
        if (typeof defConfig.data === 'function') {
            data = defConfig.data(evt);
        }

        const elDetailRow = document.createElement('tr');
        const elDetailColumn = document.createElement('td');

        elDetailRow.addClass(defConfig.className);
        elDetailColumn.setAttribute('colspan', String(elRow.cells.length || 1));
        elDetailRow.appendChild(elDetailColumn);

        // If using function format
        if (typeof defConfig.format === 'function') {
            const format = defConfig.format({
                event: evt,
                row: elRow,
                cell: elCell,
                detailRow: elDetailRow,
                detailColumn: elDetailColumn,
                data: data,
            });

            if (format != null) {
                elDetailColumn.child(format);
            }
        } else if (data != null) {
            elDetailColumn.child(data);
        }

        // If using function create child
        if (typeof defConfig.fnCreateChild === 'function') {
            defConfig.fnCreateChild({
                event: evt,
                row: elRow,
                cell: elCell,
                detailRow: elDetailRow,
                detailColumn: elDetailColumn,
                data: data,
            });
        }

        elRow.after(elDetailRow);
    });
}

function modal(element: HTMLElement, config: Record<string, any> = {}): void {
    // Default Config
    const defConfig: Record<string, any> = {
        event: 'dblclick',
        selector: 'tbody > tr > td',
    };

    // Merge
    merge(defConfig, config);

    // --------------------------------------------------------------------

    // Create event
    (window as any).$(element).on(defConfig.event, defConfig.selector, function (evt): any {
        let data = defConfig.data;

        // Create element (modal)
        const modal = exModal.start({
            merge: defConfig.modal,
            modalHeader: {
                html: exLanguage.line('general.detail'),
            },
            buttons: [
                {
                    html: exLanguage.line('general.cancel'),
                },
            ],
            destroy: true,
        });

        // If using function data
        if (typeof defConfig.data === 'function') {
            data = defConfig.data(evt);
        }

        // If using function format
        if (typeof defConfig.format === 'function') {
            const format = defConfig.format({
                event: evt,
                modal: modal,
                data: data,
            });

            // If there is format
            if (format) {
                modal.child(format).showModal();
            }
        }

        // If using function create child
        if (typeof defConfig.fnCreateChild === 'function') {
            defConfig.fnCreateChild({
                event: evt,
                modal: modal,
                data: data,
            });
        }
    });
}

// ------------------------------------------------------------------------

// ----------------------------------------------------------------------------

export { create, modal };
